import React, { useState } from "react";
import LiveEventList from "./LiveEventList";
import CreateEventModal from "./CreateEventModal";
import Subheading from "../Common/Subheading";
import EditMonitoringIcon from "../../assets/icons/monitoring/view_manage_monitors-01.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { useGetEventSolutionsQuery } from "../store/slices/settingsSlice";
import EventTableFilter from "./EventTableFilter";

import HelpButton from "../HelpContent/HelpButton";

function EventsListView() {
  const eventSolutions = useGetEventSolutionsQuery().data || [];
  const [eventSolutionUuid, setEventSolutionUuid] = useState(
    localStorage.getItem("eventsListViewEventSolution") || ""
  );
  const eventSolution = eventSolutions.find(
    (sol) => eventSolutionUuid === sol.Uuid
  );
  const [filters, setFilters] = useState({ status: ["creating", "active"] });

  return (
    <div>
      <div>
        <div className=" d-flex align-items-start">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Subheading
                Icon={EditMonitoringIcon}
                heading="View / Manage / Edit your Events"
                subheading="View and manage your events ones, and monitoring their status."
              />
            </div>
          </div>
          <Input
            inputType="select"
            value={[eventSolutionUuid]}
            onChange={([v]) => {
              setEventSolutionUuid(v);
              localStorage.setItem("eventsListViewEventSolution", v);
            }}
            placeholder="Select Event Solution"
            options={[
              { value: "", label: "Show All Events" },
              ...(eventSolutions.map((sol) => ({
                value: sol.Uuid,
                label: `Show events from ${sol.SolutionName} ${sol.SolutionVersion}`,
              })) || []),
            ]}
          />
          <div className="flex-grow-1" />
          <CreateEventModal
            key={eventSolutionUuid}
            eventSolutionUuid={eventSolutionUuid}
            from="events"
          />
        </div>
        <div className="d-flex align-items-end mb-0" />
      </div>
      <EventTableFilter filters={filters} setFilters={setFilters} />

      <div className="text-black fw-bold">
        <LiveEventList eventSolution={eventSolution} filters={filters} />
      </div>
    </div>
  );
}

export default EventsListView;
